module.exports = __webpack_public_path__ + "static/img/path.415221c4.png";